import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateFirestoreItem } from '../api/updateFirestoreItem.ts';
import { COLLECTIONS } from '../constants';
import { Filter } from '../api/getFirestoreItemByQuery.ts';

export const useUpdateFirestoreItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      collection,
      id,
      newData,
    }: {
      id: string;
      newData: Record<string, unknown>;
      collection?: string;
      filters?: Filter[];
    }) => updateFirestoreItem(id, newData, collection),
    onSuccess: (_, { collection, id, filters }) => {
      const _collection = collection || COLLECTIONS.listings;
      queryClient.invalidateQueries({ queryKey: [_collection, id] });

      if (filters) {
        queryClient.invalidateQueries({ queryKey: [_collection, filters] });
      }
    },
  });
};
